import React,{ Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './styles/style.scss';
import axios from 'axios';
import { createStore } from 'redux';
import allReducers from './redux/reducers';
import { Provider } from 'react-redux';
import './i18n';
import i18next from 'i18next';
import Loader from 'react-loader-spinner';

// Evita que el navegador sirva una respuesta de API vieja desde su caché
// HTTP (p.ej. de un deploy anterior roto) — fuerza que cada GET sea una
// petición de red nueva, agregando un parámetro que cambia siempre.
axios.interceptors.request.use((config) => {
  if ((config.method || 'get').toLowerCase() === 'get') {
    config.params = { ...(config.params || {}), _: Date.now() };
  }
  return config;
});

var userLang = navigator.language || navigator.userLanguage;
var get_lang = userLang.split("-");
var browser_langcode = get_lang[0];

if (browser_langcode === "es" || browser_langcode === "it") {
  localStorage.setItem('lang', browser_langcode);
} else {
  localStorage.setItem('lang', "en");
}

i18next.changeLanguage(browser_langcode);

const store = createStore(
  allReducers,
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
);

axios.defaults.headers.common['Authorization'] =
  localStorage.getItem('access_token');
axios.defaults.headers.common['Accept-Language'] =
  browser_langcode || 'en';

const App = React.lazy(() => import('./App'));

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={
      <div className="loadercls vh-100">
        <Loader type="ThreeDots" color="#4BC4E2" height={100} width={100}/>
      </div>
    }>
      <App />
    </Suspense>
  </Provider>,
  document.getElementById('root')
);
// 🚫 Disable CRA service worker
serviceWorker.unregister();
